import {ApiError} from "./types";

export default class TimerAlreadyRunningError extends ApiError {
    public team: string;

    constructor(json: any, team: string) {
        super(json.error, json.message);
        this.team = team;
    }
}



// WEBPACK FOOTER //
// ./src/api/errors/TimerAlreadyRunningError.ts